import Model from './BaseModel';
import MultiGroup from '@/Models/MultiGroup';

export default class MarketType extends Model {
	resourceName() {
		return 'market_types';
	}

	fields() {
		return [
			'name',
			'rule',
			'sport',
			'rolling_type',
			'traded_pre_match',
			'traded_in_play',
			'is_manual',
			'remote_id',
			'price_order',
			'label',
			'selection_win_limit_factor',
			'cashout_enabled'
		];
	}

	relationships() {
		return {
			multi_excluded_market_types: new MarketType(),
			multi_excluded_groups: new MultiGroup()
		};
	}
}
